import moment from 'moment';
import {DataColors} from '@epic-visualizations/charts';

import {axisDateFormatter, dateFormatter, timeFormatter} from './utils';
import {monthlyEndDate} from '../../../global-date-picker';
import {Payout, Playrate} from '../../../../types';
import {TimeScale} from '../../../../types';

export const DATE_NOW = moment();

export const LIVE_UPDATE_INTERVAL = 1000 * 60 * 2; // 2 minutes
export const HOURLY_UPDATE_INTERVAL = 1000 * 60 * 60; // 1 hour

export const AUTO_UPDATED_TIMESCALES = [TimeScale.LIVE, TimeScale.HOURLY];

export const LEGENDS_LIMIT = 10;

export const VERSION_TICK_FORMAT = 'YYYY-MM-DDTHH:mm';

export const DATE_FORMAT = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
};

export const NUMERIC_DATE_FORMAT = {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
};

export const TIME_FORMAT = {
    hour: 'numeric',
    minute: 'numeric'
};

export const WEEK_DATE_FORMAT = {
    ...DATE_FORMAT,
    weekday: 'short'
};

export const PERCENT_FORMAT = {
    style: 'percent'
};

export const PERCENT_FORMAT_SINGLE_FRACTION = {
    ...PERCENT_FORMAT,
    maximumFractionDigits: 1
};

export const PERCENT_FORMAT_DOUBLE_FRACTION = {
    ...PERCENT_FORMAT,
    maximumFractionDigits: 2
};

export const COMPACT_CURRENCY_FORMAT = {
    style: 'currency',
    currency: 'USD',
    notation: 'compact'
};

export const CURRENCY_FORMAT = {
    ...COMPACT_CURRENCY_FORMAT,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};

export const MIN_WAU = 100;

export const SHOW_HOURS_LIMIT = 96;

export const PDF_PAGE_OPTIONS = {
    orientation: 'l',
    pageFormat: 'a4'
};

export const tooltipFormatters = {
    [TimeScale.LIVE]: timeFormatter,
    [TimeScale.HOURLY]: timeFormatter,
    [TimeScale.DAILY]: dateFormatter(),
    [TimeScale.WEEKLY]: dateFormatter(),
    [TimeScale.MONTHLY]: dateFormatter()
};

export const xAxisFormatters = {
    [TimeScale.LIVE]: timeFormatter,
    [TimeScale.HOURLY]: axisDateFormatter,
    [TimeScale.DAILY]: axisDateFormatter,
    [TimeScale.WEEKLY]: dateFormatter(NUMERIC_DATE_FORMAT),
    [TimeScale.MONTHLY]: dateFormatter(NUMERIC_DATE_FORMAT)
};

export const TimeUnit = {
    [TimeScale.HOURLY]: 'hour',
    [TimeScale.DAILY]: 'day'
};

export const REWARDS_PRESELECTED_DATE_RANGE = {
    startDate: moment(DATE_NOW)
        .subtract(12, 'months')
        .startOf('month'),
    endDate: monthlyEndDate(DATE_NOW),
    selectedDate: monthlyEndDate(DATE_NOW)
};

export const REWARDS_DATA_COLORS: DataColors = {
    [Payout.ENGAGEMENT]: 13,
    [Payout.SAC]: 8
};

export const PLAYRATE_DATA_COLORS: DataColors = {
    [Playrate.CURRENT]: 4,
    [Playrate.PREVIOUS]: 2
};

export const GAME_XP_PRESELECTED_DATE_RANGE = {
    startDate: moment(DATE_NOW).startOf('day'),
    endDate: DATE_NOW.endOf('day'),
    selectedDate: DATE_NOW
};

export enum DateRangePickerOption {
    PRESELECTED = 'preselected',
    CUSTOM = 'custom'
}
